module.exports = __webpack_public_path__ + "static/img/green.b37ce5d5.png";